import styled from 'styled-components'

export const FiltersWrapper = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 48px;
`

export const BoxDefaultCentered = styled.span`
  display: block;
  width: fit-content;
  text-align: center;
  margin: 0 auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1.3;
`
